export var stringToDashAndLowerCase = function stringToDashAndLowerCase(string) {
  return string.trim().replace(/[^a-zA-Z0-9- ]/g, '') // remove special characters
  .replace(/\s+/g, '-') // replace space with dash
  .replace(/^-+|-+(?=-|$)/g, '') // replace duplicate dash to one
  .toLowerCase();
};